import $ from 'jquery';

window.initMap = async () => {
	const { Map } = await google.maps.importLibrary('maps');
	const { Marker, PinElement } = await google.maps.importLibrary("marker");
	const maps = document.querySelectorAll('.js-map');

	maps.forEach((map, idx) => {
		let $map = $(map);
		const gmap = new Map(map, {
			center: { lat: $map.data('lat'), lng: $map.data('lng') },
			zoom: 17,
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: true,
			streetViewControl: false,
			overviewMapControl: false,
			rotateControl: true,
			styles: [
				{
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#271437"
					}
				  ]
				},
				{
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#8ec3b9"
					}
				  ]
				},
				{
				  "elementType": "labels.text.stroke",
				  "stylers": [
					{
					  "color": "#1a3646"
					}
				  ]
				},
				{
				  "featureType": "administrative",
				  "elementType": "geometry",
				  "stylers": [
					{
					  "visibility": "off"
					}
				  ]
				},
				{
				  "featureType": "administrative.country",
				  "elementType": "geometry.stroke",
				  "stylers": [
					{
					  "color": "#4b6878"
					}
				  ]
				},
				{
				  "featureType": "administrative.land_parcel",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#64779e"
					}
				  ]
				},
				{
				  "featureType": "administrative.province",
				  "elementType": "geometry.stroke",
				  "stylers": [
					{
					  "color": "#4b6878"
					}
				  ]
				},
				{
				  "featureType": "landscape.man_made",
				  "elementType": "geometry.stroke",
				  "stylers": [
					{
					  "color": "#291438"
					}
				  ]
				},
				{
				  "featureType": "landscape.natural",
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#271436"
					}
				  ]
				},
				{
				  "featureType": "poi",
				  "stylers": [
					{
					  "visibility": "off"
					}
				  ]
				},
				{
				  "featureType": "poi",
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#283d6a"
					}
				  ]
				},
				{
				  "featureType": "poi",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#6f9ba5"
					}
				  ]
				},
				{
				  "featureType": "poi",
				  "elementType": "labels.text.stroke",
				  "stylers": [
					{
					  "color": "#1d2c4d"
					}
				  ]
				},
				{
				  "featureType": "poi.park",
				  "elementType": "geometry.fill",
				  "stylers": [
					{
					  "color": "#023e58"
					}
				  ]
				},
				{
				  "featureType": "poi.park",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#3C7680"
					}
				  ]
				},
				{
				  "featureType": "road",
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#301a44"
					}
				  ]
				},
				{
				  "featureType": "road",
				  "elementType": "labels.icon",
				  "stylers": [
					{
					  "visibility": "off"
					}
				  ]
				},
				{
				  "featureType": "road",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#98a5be"
					}
				  ]
				},
				{
				  "featureType": "road",
				  "elementType": "labels.text.stroke",
				  "stylers": [
					{
					  "color": "#1d2c4d"
					}
				  ]
				},
				{
				  "featureType": "road.highway",
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#2c6675"
					}
				  ]
				},
				{
				  "featureType": "road.highway",
				  "elementType": "geometry.stroke",
				  "stylers": [
					{
					  "color": "#301a44"
					}
				  ]
				},
				{
				  "featureType": "road.highway",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#b0d5ce"
					}
				  ]
				},
				{
				  "featureType": "road.highway",
				  "elementType": "labels.text.stroke",
				  "stylers": [
					{
					  "color": "#023e58"
					}
				  ]
				},
				{
				  "featureType": "transit",
				  "stylers": [
					{
					  "visibility": "off"
					}
				  ]
				},
				{
				  "featureType": "transit",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#98a5be"
					}
				  ]
				},
				{
				  "featureType": "transit",
				  "elementType": "labels.text.stroke",
				  "stylers": [
					{
					  "color": "#1d2c4d"
					}
				  ]
				},
				{
				  "featureType": "transit.line",
				  "elementType": "geometry.fill",
				  "stylers": [
					{
					  "color": "#283d6a"
					}
				  ]
				},
				{
				  "featureType": "transit.station",
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#3a4762"
					}
				  ]
				},
				{
				  "featureType": "water",
				  "elementType": "geometry",
				  "stylers": [
					{
					  "color": "#0e1626"
					}
				  ]
				},
				{
				  "featureType": "water",
				  "elementType": "labels.text.fill",
				  "stylers": [
					{
					  "color": "#4e6d70"
					}
				  ]
				}
			  ]
		});

		const markerPosition = { lat: $map.data('lat'), lng: $map.data('lng') };
		const marker = new Marker({
			map: gmap,
			position: markerPosition,
			icon: resources.path + "/images/pin.svg"
		})
	})
}
